export const isDevelopment = process.env.NEXT_PUBLIC_DEVELOPMENT === 'true';
